(function () {
  var dynamicLoading = {
      css: function (path) {
          var head = document.getElementsByTagName('head')[0];
          var link = document.createElement('link');
          link.href = path;
          link.rel = 'stylesheet';
          link.type = 'text/css';
          head.appendChild(link);
      },
      js: function (path, callback, onFailed) {
          var head = document.getElementsByTagName('head')[0];
          var script = document.createElement('script');
          script.src = path;
          script.type = 'text/javascript';
          script.async = false
          script.onload = script.onreadystatechange = function () {
              callback && callback()
          };
          if (onFailed && typeof (onFailed) == "function") {
              script.onerror = onFailed;
          }
          head.appendChild(script);
      },
      type: 't2024081402',
      time: '1723600210'
  }


var flipbookAsstes = window.Resource.flipbook;
dynamicLoading.js(flipbookAsstes.flbDeStringJs);
dynamicLoading.js(flipbookAsstes.flbJqueryMinJs)
dynamicLoading.css(flipbookAsstes.flbStyleCss)
dynamicLoading.js(flipbookAsstes.flbBookMinJs)

// var time = new Date().getTime()
var pageEditorJs = flipbookAsstes.flbReaderConfigJs
var editorTextSvgConfigJs = flipbookAsstes.flbTextSvgConfigJs
var indexEditorAppCss = flipbookAsstes.flbAppCss;
var indexEditorChunkVendorsCss = flipbookAsstes.flbChunkVendorsCss;
var indexEditorAppJs = flipbookAsstes.flbAppJs;
var indexEditorChunkVendorsJs = flipbookAsstes.flbChunkVendorsJs;

var loadPageEditorJs = true;
// if(typeof htmlConfig != 'undefined' && typeof htmlConfig['fileExist'] != 'undefined' && typeof htmlConfig['fileExist']['pageEditor'] != 'undefined') {
//   loadPageEditorJs = htmlConfig['fileExist']['pageEditor'] == 1 ? true : false;
// }
if(loadPageEditorJs) {
  dynamicLoading.js(pageEditorJs, function () {
      window.readerConfigLoaded = true;
      if (window.readerConfig &&
          window.readerConfig.pages.length > 0
      ) {
          dynamicLoading.css(indexEditorAppCss)
          dynamicLoading.css(indexEditorChunkVendorsCss)
          dynamicLoading.js(editorTextSvgConfigJs)
          dynamicLoading.js(indexEditorAppJs)
          dynamicLoading.js(indexEditorChunkVendorsJs)
      }
  }, function () {
      window.readerConfigLoaded = true;
  })
} else {
  window.readerConfigLoaded = true;
}

if(window.htmlConfig && window.htmlConfig.pageEditor) window.pageEditor = window.htmlConfig.pageEditor;
window.pageEditorUrl = flipbookAsstes.flbPageItemsMinJs;
if (window.pageEditor &&
  ((!pageEditor.pageAnnos && pageEditor.length > 0) ||
      (pageEditor.pageAnnos && pageEditor.pageAnnos.length > 0))) {
  dynamicLoading.js(pageEditorUrl)
}
window.pageEditorUrl = null;

// window.pageSliderUrl = 'javascript/LoadingJS.js';
// if (window.sliderJS &&
//   window.sliderJS.length > 0) {
//   dynamicLoading.js(pageSliderUrl)
// }
// window.pageSliderUrl = null;

dynamicLoading.js(flipbookAsstes.flbMainMinJs)

  // try {
  //     if(window.htmlConfig && window.htmlConfig.phoneTemplate) {
  //         if(window.htmlConfig.phoneTemplate.name && window.htmlConfig.phoneTemplate.name == 'neat') {
  //             var toolbarUrl = window.htmlConfig.phoneTemplate.path + 'PhoneToolBar.min.js?' + new Date().getTime();
  //             dynamicLoading.js(toolbarUrl)
  //         }
  //     }
  // } catch (error) {
      
  // }
})();
